<template>
  <div class="checkin__last-call w-100 d-flex align-items-center justify-content-between" v-if="!expired">
    <div class="checkin__last-call__message">
      <Icon name="alertTriangle" width="20" class="checkin__last-call__icon"/>
      <span class="checkin__last-call__text">{{ $t('pages.checkin_info_media.list_message') }}</span>
    </div>
    <b-button size="sm" class="checkin__last-call__cta text-nowrap" variant="outline">
      {{ $t('pages.checkin_info_media.list_cta') }}
    </b-button>
  </div>
</template>
<script>
export default {
  name: "InfoSdHdAvailableList",
  props: {
    hdAvailableTo: {
      type: String,
      required: true
    }
  },
  computed: {
    expired() {
      return new Date(this.hdAvailableTo) < new Date()
    },
  },
}
</script>


<style scoped>

</style>